import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "am_session_token";
const EXPO_TOKEN_KEY = "am_expositor_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getExpositorToken = () => localStorage.getItem(EXPO_TOKEN_KEY) || "";
export const setExpositorToken = (t) => {
  if (t) localStorage.setItem(EXPO_TOKEN_KEY, t);
  else localStorage.removeItem(EXPO_TOKEN_KEY);
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  const et = getExpositorToken();
  if (et) {
    config.headers = config.headers || {};
    config.headers["X-Expositor-Token"] = et;
  }
  return config;
});

export const formatUSD = (n) =>
  new Intl.NumberFormat("es-AR", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);
